// Canal Boats Telemark master logo (extracted from official brand guide PDF, page 06).
export default function Logo({ size = 40, withText = true, dark = false }) {
  const src = dark ? "/logo-dark.png" : "/logo-light.png";
  // Trimmed logo aspect ratio ~2200/1134 ≈ 1.94:1 (incl. wave emblem + 2 lines of text)
  const height = withText ? size * 1.55 : size;
  return (
    <div className="inline-flex items-center" data-testid="brand-logo">
      <img
        src={src}
        alt="Canal Boats Telemark"
        style={{ height }}
        className="w-auto max-w-none object-contain select-none"
        draggable={false}
      />
    </div>
  );
}
